import React, { useState } from 'react'
import child from "../../Images/childdepretionimage.jpg"
import Button from '../../commanfile/Button'
import Servicelist from '../../commanfile/Servicelist'
import ServiceSlider from '../../commanfile/ServiceSlider'
import childcare from "../../Images/hildcareimage2.webp"
import comit from "../../Images/childcareimage3.jpg"
import { FaHandHoldingHeart } from 'react-icons/fa6'


const Child = () => {
  const symtams1 = [
    "Helps children manage emotional and behavioral problems",
    "Strengthens parent-child relationships",
    "Builds self-esteem and confidence in children",
    "Supports healthy development and coping strategies",
    "Improves communication and social skills",
  ]
  const symtams = [
    "Guides parents with effective parenting techniques",
    "Helps prevent future mental health issues",
    "Promotes positive thinking and emotional resilience",
    "Provides support for anxiety, ADHD, autism, and trauma",
    "Identifies learning difficulties or developmental delays early"
  ]

  const Data = [
 
    {
      question: " 	What is child guidance? ",
      answer: "	Child guidance is a professional support system helping children deal with emotional, behavioral, and developmental challenges through counseling and therapy tailored to their needs."
    },
    {
      question: "	When should parents seek professional help for their child? ",
      answer: "	Parents should seek help if their child shows persistent behavioral issues, emotional distress, academic struggles, or difficulty in social relationships."
    },
    {
      question: "	What kinds of issues does child guidance address? ",
      answer: "	Child guidance addresses problems like anxiety, depression, behavioral disorders, learning difficulties, family conflicts, and social skills challenges."
    }, {
      question: "	How is child guidance different from regular counseling? ",
      answer: "Child guidance is specialized counseling focusing on children's unique developmental and emotional needs, often involving parents and school collaboration."
    },

    {
      question: "	Can child guidance help with behavioral problems like anger or hyperactivity?  ",
      answer: " 	Yes, child guidance can effectively address behavioral problems such as anger, hyperactivity, and conduct issues through tailored interventions."
    },
    {
      question: " 	Does my child need therapy if they are struggling in school?  ",
      answer: " Struggling in school may indicate underlying emotional or learning issues; child guidance can assess and provide appropriate support."
    },
    {
      question: " 	How can child guidance support children with anxiety or depression?  ",
      answer: " 	It helps children manage anxiety and depression by teaching coping skills, emotional regulation, and building resilience."
    },
       {
      question: "What role do parents play in child guidance sessions?  ",
      answer: "Parents participate actively in sessions, helping understand the child's needs, reinforcing strategies, and supporting progress."
    },
    {
      question: " 	Can therapy help my child with social skills and peer relationships? ",
      answer: "	Therapy can improve social skills, communication, and peer relationships through role-playing, social stories, and skill-building exercises."
    },
  
    {
      question: "Is child guidance only for children with serious problems? ",
      answer: " Child guidance supports children with various needs, not only those with serious problems, promoting overall well-being."
    },
    {
      question: " 	What types of therapies are used in child guidance? ",
      answer: "	Therapies include play therapy, cognitive-behavioral therapy (CBT), family therapy, and art or music therapy."
    },
    {
      question: " How long does it usually take for a child to show progress? ",
      answer: "	Progress varies; some children improve quickly, while others may need months of consistent support."
    }, {
      question: "	Is everything my child shares kept confidential? ",
      answer: " Confidentiality is maintained with consideration of the child’s safety and parental rights."
    },
    {
      question: " Can parents also receive guidance to better support their child? ",
      answer: "	Yes, parents often receive guidance to better support their child's emotional and behavioral needs."
    },
    {
      question: "	Does child guidance also help teenagers? ",
      answer: "Child guidance is effective for teenagers, addressing adolescent-specific challenges and transitions."
    },
    {
      question: "How do I explain therapy to my child so they feel comfortable? ",
      answer: "Explain therapy as a safe, supportive space to talk and learn, ensuring it’s framed positively and age-appropriately."
    },

  ]


  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }


  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto  ">
        <div className=" bg-gradient-to-r from-[#469B8F] pb-8">
          <ServiceSlider
          classname={"md:flex p-2 flex-row-reverse"}
            title={"CHILD GUIDANCE"}
            content={
              "Child guidance is not about pointing out flaws—it is about nurturing growth. "
            }
            maincontent={
              "Every child faces challenges, whether emotional, behavioral, or developmental, and with the right support, they can overcome them with confidence. Guidance helps children understand their feelings, build resilience, and develop healthier ways of coping with the world around them. It also empowers parents to better support their child’s journey. Remember, seeking guidance is not a sign of failure—it is an act of love and care that helps children thrive."}
            buttonname={"Explore Treatment Option "}
            imgs={child}
             
            
          />
        </div>
        <div className="py-16 ">
          <div className="text-center border-b-4 p-2">
            <p className="font-roboto text-3xl line-clamp-5 ">
              Building Stronger Futures with Child Counseling
            </p>
            <div className="md:flex  flex-row-reverse mx-auto justify-around py-8 ">
              <div className=" ">
                <img
                src={childcare}
                  className="border-black mx-auto rounded-2xl h-[300px] w-[350px]"
                />
              </div>
              <div>
                <div className="lg:flex justify-between mx-auto  px-3 gap-10 ">
                  <div className=" ">
                    <Servicelist Symtams={symtams} />
                  </div>
                  <div className="">
                    <Servicelist Symtams={symtams1} />
                  </div>
                </div>
                <div className="mx-auto pt-10 ">
                  <Button
                    className={
                      "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#50b1a4] p-1 rounded-full h-[40px] w-[200px]"
                    }
                    btnName={"Get Appointment"}
                    link={"/ContactUs"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto py-8">
          <div className="md:flex p-2 flex-row-reverse justify-around pt-5 items-center">
            <div className="md:w-[50%]  w-full">
              <p className=" flex gap-2 font-roboto font-semibold uppercase text-3xl text-[#469B8F]">
                <FaHandHoldingHeart />
                 Supporting Minds, Changing Lives
              </p>

              <p className=" mx-auto text-justify text-lg py-5 px-5">
                The Child Guidance Clinic at Psynexa is dedicated to help children of varying intellectual abilities who face psychological or behavioural challenges. Our experts provide compassionate care for issues like Bedwetting (Nocturnal Enuresis), Autism Spectrum Disorder (ASD)—marked by social and communication challenges, and ADHD, characterized by inattention, impulsivity, and hyperactivity. We also treat Childhood Depression, Separation Anxiety Disorder, and behavioral conditions such as Conduct Disorder and Oppositional Defiant Disorder, helping children build healthier emotional responses and adaptive coping skills.
              </p>
            </div>
            <div className="">
              <img
                src={comit}
                className="w-[400px] h-[400px] shadow-black shadow-2xl rounded-full "
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>


    </>

  )
}

export default Child